import React from 'react'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { CustomNavigationClient } from '@utils/AzureNavigationClient'

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: process.env.GATSBY_AUTH_CLIENT_ID,
    authority: process.env.GATSBY_AUTH_AUTHORITY,
    knownAuthorities: process.env.GATSBY_AUTH_KNOWN_AUTHORITIES
      ? process.env.GATSBY_AUTH_KNOWN_AUTHORITIES.split(',')
      : [],
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  graph: {
    endpoint: 'https://graph.microsoft.com/',
    scopes: ['User.Read'],
  },
}

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: process.env.GATSBY_AUTH_SCOPES.split(',') || ['User.Read'],
}

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphPhotoEndpoint: 'https://graph.microsoft.com/v1.0/me/photo/$value',
  graphPhotoUserEndpoint: 'https://graph.microsoft.com/v1.0/users',
}

const msalInstance = new PublicClientApplication(msalConfig)

export default ({ element }) => {
  // The next 2 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const navigationClient = new CustomNavigationClient()
  msalInstance.setNavigationClient(navigationClient)

  // Force redirect to login page if auth error (remove if want to navigate to 404 page)
  // msalInstance
  //   .handleRedirectPromise()
  //   .then(function (response) {
  //     //success response
  //   })
  //   .catch((error) => {
  //     console.error(error)
  //   })

  return <MsalProvider instance={msalInstance}>{element}</MsalProvider>
}
